import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">
      {/* Sidebar component for desktop */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content area */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden md:ml-64">
        <Navbar />
        
        {/* Mobile sidebar toggle button */}
        <div className="md:hidden pl-4 pt-4">
          <button 
            onClick={() => setSidebarOpen(true)} 
            className="flex items-center justify-center h-10 w-10 rounded-md text-whatsapp-green hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-whatsapp-green"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
            </svg>
          </button>
        </div>
        
        {/* Main content */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none h-[calc(100vh-64px)]">
          <div className="py-6 px-4 sm:px-6 md:px-8 h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
